// src/components/CreateSubscriptionModal.tsx

import React from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { Subscription } from '../types';

interface CreateSubscriptionModalProps {
  show: boolean;
  onHide: () => void;
  formData: Subscription;
  handleFormChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleSubmit: (e: React.FormEvent) => void;
}

const CreateSubscriptionModal: React.FC<CreateSubscriptionModalProps> = ({
  show,
  onHide,
  formData,
  handleFormChange,
  handleSubmit
}) => {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Create New Plesk Subscription</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="subscriptionDomainName">
            <Form.Label>Domain Name</Form.Label>
            <Form.Control
              type="text"
              name="domainName"
              required
              value={formData.domainName}
              onChange={handleFormChange}
            />
          </Form.Group>
          <Button variant="primary" type="submit">
            Create Subscription
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default CreateSubscriptionModal;
